import { z } from 'zod';
import type { TFunction } from 'i18next';
import type { BankAddressField } from '@/entities/bank-address';

export const createBankAddressSchema = (
  t: TFunction,
  fields: BankAddressField[],
  isLastStep: boolean
) => {
  const requiredMessage = t('common.requiredField');
  const schemaFields: Record<string, z.ZodTypeAny> = {};

  fields.forEach(field => {
    if (field.required) {
      schemaFields[field.id] = z
        .string({ message: requiredMessage })
        .nonempty({ message: requiredMessage });
    } else {
      schemaFields[field.id] = z.string().optional();
    }
  });

  if (isLastStep) {
    schemaFields.templateName = z
      .string()
      .nonempty({ message: requiredMessage });
  }

  return z.object(schemaFields);
};
